//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { Button, Typography } from "@mui/material";
import React from "react";
import { FieldValues, UseFormReturn } from "react-hook-form";
import { DocumentManagerActions } from "@siba/components";
import { IIssue } from "Application/features/models/Issue/IIssue";
import { Paperclip } from "react-feather";

interface IssueReviewFormInterface {
    formHandler: UseFormReturn<FieldValues, object>;
    disableFieldUpdate: boolean;
    saveMethod: any;
    model: IIssue;
}

/**
 * Branch form modal component
 * @param props
 * @returns
 */
const IssueReviewModalForm: React.FC<IssueReviewFormInterface> = (props) => {
    const { formHandler, model } = props;

    // const changeDetailIndex = (newIndex: any) => {
    //     setCurrentDetailIndex(newIndex);
    // };

    return (
        <div style={{ padding: "30px", height: "70vh" }}>
            <div className="row" style={{ display: "flex", justifyContent: "center", marginBottom: "1em" }}>
                <div className="col-md-12 col-sm-12 " style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "" }}></div>
            </div>
            <div className="row" style={{ display: "flex", justifyContent: "center", marginBottom: "1em" }}>
                <div className="col-md-12 col-sm-12 " style={{ marginBottom: "1em" }}>
                    <>
                        <div style={{ width: "100%" }}>
                            <div style={{ marginBottom: "10px" }}>
                                <Typography variant="h5" gutterBottom>
                                    Reported By: {model.reportedBy}
                                </Typography>
                            </div>

                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <div style={{ flex: 1, marginRight: "20px" }}>
                                    <Typography variant="body1" gutterBottom>
                                        Application: {model.applicationName}
                                    </Typography>
                                </div>
                                <div style={{ flex: 1, marginRight: "20px" }}>
                                    <Typography variant="body1" gutterBottom>
                                        Category: {model.category}
                                    </Typography>
                                </div>
                                <div style={{ flex: 1 }}>
                                    <Typography variant="body1" gutterBottom>
                                        Due on: {model.dueDate}
                                    </Typography>
                                </div>
                            </div>

                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <div style={{ flex: 2, marginRight: "20px" }}>
                                    <Typography variant="body1" gutterBottom>
                                        Subject: {model.subject}
                                    </Typography>
                                </div>
                                <div style={{ flex: 1 }}>
                                    <Typography variant="body1" gutterBottom>
                                        Priority: {model.priority}
                                    </Typography>
                                </div>
                            </div>

                            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        DocumentManagerActions.handleDocuments({
                                            transactionId: model.id || "",
                                            transactionName: "Document Upload"
                                        });
                                    }}
                                    startIcon={<Paperclip size={18} />}
                                >
                                    Attach Document
                                </Button>
                            </div>
                        </div>
                        <hr />
                        <div
                            style={{
                                height: "450px",
                                overflowY: "auto",
                                margin: "0 auto",
                                backgroundColor: "#f2f2f2",
                                padding: "20px",
                                boxSizing: "border-box",
                                border: "2px solid #f2f2f2",
                                borderRadius: "8px",
                                boxShadow: "inset 0px 0px 2px rgba(0, 0, 0, 0.1)"
                            }}
                        >
                            <div dangerouslySetInnerHTML={{ __html: model.description }}></div>
                        </div>
                    </>
                </div>
            </div>
        </div>
    );
};

export default IssueReviewModalForm;
